import React,  { useState } from 'react';
import { useNavigate } from "react-router-dom";
import './App.css'; 

function LandingPage() {
    const navigate = useNavigate();

    const questions = [
        { question: "Which month did we visit Japan? 🇯🇵", answer: "may" },
        { question: "Which borough did I pick you up from for the first time in my new car?🚗", answer: "erith" },
        { question: "What's the name of the hotel we're going to? 🏨", answer: "foxhills" },
    ];

    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [userAnswer, setUserAnswer] = useState("");
    const [feedback, setFeedback] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        const correctAnswer = questions[currentQuestion].answer.toLowerCase().trim();
        const userResponse = userAnswer.toLowerCase().trim();

        if (userResponse === correctAnswer) {
        setFeedback("✅ Correct!");
        if (currentQuestion + 1 < questions.length) {
            setCurrentQuestion(currentQuestion + 1);
            setUserAnswer("");
        } else {
            navigate("/foxhills");
        }
        } else {
        setFeedback("❌ Nope, try again!");
        }
    };


    return (
        <div className="container">
            <h1 className="header">YOGZZLE!</h1>
            <p className="paragraph">😲 Wow, a whole other year of you putting up with me! 😲</p>
            <p className="paragraph">🏃‍♀️ We've gone on a lot of adventures this year, it'll help you with the quiz 🏃‍♀️</p>
            <p className="paragraph">❤️ I can't wait for the next year we have together ❤️</p>
            <p className="paragraph">🏁 Answer the questions below to access the puzzle! 🏁</p>

            {/* Question Box */}
            <div className="question-box">
                <h2 className="question">{questions[currentQuestion].question}</h2>
                <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    placeholder="Type your answer..."
                    value={userAnswer}
                    onChange={(e) => setUserAnswer(e.target.value)}
                    className="input"
                />
                <button type="submit" className="button">
                    Submit
                </button>
                </form>
                {feedback && <p className="feedback">{feedback}</p>}
            </div>
            </div>
    );

}

export default LandingPage;